<template>
  <div>
    <Row>
      <Col span="18">
        <Input v-model="name" placeholder="请输入名称" class="public-inp" />
        <Button
          type="primary"
          icon="md-search"
          @click="getList()"
          v-access="'serviceInfo.query'"
          >搜索</Button
        >
        <Button @click="resetList()" v-access="'serviceInfo.reset'"
          >重置</Button
        >
      </Col>
      <Col span="6">
        <Button
          type="primary"
          icon="md-add"
          class="public-fr"
          v-access="'serviceInfo.add'"
          @click="openFn()"
          >添加</Button
        >
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row, index }" slot="sort">
            <span v-show="false">{{ row.code }}</span>
            {{ (page - 1) * pageSize + index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="avatar">
            <Avatar v-if="row.lecienceImgUrl" :src="row.lecienceImgUrl" />
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <a
              href="javascript:;"
              @click="openFn(row, index)"
              v-access="'serviceInfo.edit'"
              >编辑</a
            >
            <a
              href="javascript:;"
              @click="deletehandler(row, index)"
              v-access="'serviceInfo.delete'"
              >删除</a
            >
          </template>
        </Table>
        <Page
          :total="total"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          show-elevator
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
          class="public-page"
        />
      </Col>
    </Row>
    <Modal
      v-model="deleteModal"
      title="删除提醒"
      @on-ok="deletehandler2"
      @on-cancel="cancelDetele"
    >
      <p>确定删除该条数据吗？</p>
    </Modal>
  </div>
</template>
<script>
const columns = [
  {
    title: "序号",
    slot: "sort",
    width: 60,
  },
  {
    title: "名称",
    key: "name",
  },
  {
    title: "主体信息",
    key: "businessInfo",
  },
  {
    title: "达能经销商名称",
    key: "elnDealerName",
  },
  {
    title: "联系人",
    key: "contacTperson",
  },
  {
    title: "联系电话",
    key: "contactMobile",
  },
  {
    title: "地址",
    key: "addr",
    render: (h, params) => {
      let d = params.row;
      let t = d.provinceName + d.cityName + d.addr;
      return h("span", t);
    },
  },
  {
    title: "营业执照号",
    key: "lecienceCode",
  },
  {
    title: "营业执照名称",
    key: "lecienceName",
  },
  {
    title: "营业执照图片",
    slot: "avatar",
  },
  {
    title: "状态",
    key: "status",
    render: (h, params) => {
      let s = params.row.status;
      let t = s == 1 ? "停用" : "正常";
      return h("span", t);
    },
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
export default {
  data() {
    return {
      loading: false,
      name: "",
      columns,
      tbList: [],
      total: 0,
      page: 1,
      pageSize: 10,

      deleteModal: false,
      currentRow: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      let data = {
        stype: 1,
        name: this.name,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$api.spSearch(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
    // 重置
    resetList() {
      this.name = "";
      this.page = 1;
      this.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    openFn(d, i) {
      this.$router.replace({
        path: "/serviceEdit",
        query: { code: d ? d.code : "" },
      });
    },
    // deletehandler(d,i){
    //   this.$store.dispatch("merchant/shopInfoDel", {code: d?d.code:''}).then(res => {
    //     if(res.code == 200){
    //       this.$Message.success("删除成功");
    //       this.getList();
    //     }else{
    //       this.$Message.error(res.message || "删除失败");
    //     }
    //   })
    // },
    deletehandler(row, index) {
      this.deleteModal = true;
      this.currentRow = row;
    },
    cancelDetele() {
      this.currentRow = null;
    },
    deletehandler2() {
      if (this.currentRow && this.currentRow.code) {
        const code = this.currentRow.code;
        this.$store
          .dispatch("merchant/shopInfoDel", { code: code })
          .then((res) => {
            if (res.code == 200) {
              this.$Message.success("删除成功");
              this.getList();
            } else {
              this.$Message.error(res.message || "删除失败");
            }
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/other/serviceInfo.vue